import {
  applyMiddleware,
  createStore,
  compose,
  Store,
  Reducer,
  Middleware,
  DeepPartial,
} from 'redux';
import { queryMiddleware } from 'redux-query';
import superagentInterface from 'redux-query-interface-superagent';
import thunk from 'redux-thunk';
import { State } from 'types';
import reduxQueryConfigEnhancer from './reduxQueryConfigEnhancer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  : compose;

const getQueries = (state: State): {} => state.queries;
const getEntities = (state: State): {} => state.entities;
const middlewares: Middleware[] = [
  thunk,
  reduxQueryConfigEnhancer,
  queryMiddleware(superagentInterface, getQueries, getEntities),
];

/**
 * Creates a redux store with a default set of middleware.
 */
export default function createAppStore(
  reducer: Reducer,
  preloadedState?: DeepPartial<unknown>,
): Store {
  return createStore(reducer, preloadedState, composeEnhancers(applyMiddleware(...middlewares)));
}
